// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { JobRead } from "./JobRead";
import {
  JobReadFromJSON,
  JobReadFromJSONTyped,
  JobReadToJSON,
  JobReadToJSONTyped,
} from "./JobRead";

/**
 *
 * @export
 * @interface PageJobRead
 */
export interface PageJobRead {
  /**
   *
   */
  total: number;
  /**
   *
   */
  items: Array<JobRead>;
  /**
   *
   */
  limit?: number | null;
  /**
   *
   */
  offset?: number | null;
}

/**
 * Check if a given object implements the PageJobRead interface.
 */
export function instanceOfPageJobRead(value: object): value is PageJobRead {
  if (!("total" in value) || value["total"] === undefined) return false;
  if (!("items" in value) || value["items"] === undefined) return false;
  return true;
}

export function PageJobReadFromJSON(json: any): PageJobRead {
  return PageJobReadFromJSONTyped(json, false);
}

export function PageJobReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageJobRead {
  if (json == null) {
    return json;
  }
  return {
    total: json["total"],
    items: (json["items"] as Array<any>).map(JobReadFromJSON),
    limit: json["limit"] === undefined ? undefined : json["limit"] === null ? null : json["limit"],
    offset:
      json["offset"] === undefined ? undefined : json["offset"] === null ? null : json["offset"],
  };
}

export function PageJobReadToJSON(json: any): PageJobRead {
  return PageJobReadToJSONTyped(json, false);
}

export function PageJobReadToJSONTyped(
  value?: PageJobRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    total: value["total"],
    items: (value["items"] as Array<any>).map(JobReadToJSON),
    limit: value["limit"],
    offset: value["offset"],
  };
}
